var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { MqlListener } from '../mql-listener';
import { Fullscreen } from '../fullscreen';
import { ButtonFieldIconClosePrivate } from '../button-field-icon-close-private';
import { Iconsvg } from '../iconsvg';
import { SrOnly } from '../sr-only';
import { smartPlacement } from '../lib-smartPlacement';
import { scrollLock } from '../lib-scrollLock';
import { getFocusables } from '../lib-getFocusables';
import { focusTrap } from '../lib-focusTrap';
import { clickOutside } from '../lib-clickOutside';
import { BREAKPOINTS_FROM } from '../lib-breakpoints';
import { DEFAULT_DROPDOWN_I18N } from '../dropdown-resources';
import { findTargetForAngular } from '../lib-findTargetForAngular';
import { assignAndGetId } from '../lib-assignAndGetId';
import { focusFirstAvailable } from '../lib-focusFirstAvailable';
import { isSsr } from '../lib-ssr';
import { dropdownMobileViewChangeEvent, dropdownMobileViewChangeEventCunsumersSelector, dropdownRecursiveFindingLastItem } from '../dropdown-lib';
import { ARROW_KEYS, DOWN_KEYS, UP_DOWN_KEYS, UP_KEYS } from '../lib-menuFocus';
import { componentApi } from '../component-api-lib';
import * as React from 'react';
var Dropdown = /** @class */ (function (_super) {
    __extends(Dropdown, _super);
    function Dropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.emit = componentApi.emit.bind(_this);
        _this.writeState = componentApi.writeState.bind(_this);
        _this.dropdownRef = React.createRef();
        _this.dropdownDocRef = React.createRef();
        _this.closeMobileViewBtnRef = React.createRef();
        _this.dropdownMenuAreaRef = React.createRef();
        _this.cgThrottle = componentApi.cgThrottle.bind(_this);
        _this.toCancel = [];
        _this.cgRequestAnimationFrame = componentApi.cgRequestAnimationFrame.bind(_this);
        _this.cgDebounce = componentApi.cgDebounce.bind(_this);
        _this.moreBtnId = '';
        _this.timeoutIds = [];
        _this._closeHandler = function (closeReason) {
            var handler = _this.props.closeHandler || _this._defaultCloseHandler;
            handler(closeReason);
        };
        _this._defaultCloseHandler = function (closeReason) {
            if (closeReason !== 'focusOut') {
                _this.focusTargetIfExist();
            }
        };
        _this._target = null;
        _this._isMobile = false;
        _this.notifyChildrenAboutMobileView = _this.cgThrottle(function (isMobile) {
            var _a;
            var mobileViewChangeEvent = dropdownMobileViewChangeEvent(isMobile);
            var allDependentChildren = ((_a = _this.dropdownMenuArea()) === null || _a === void 0 ? void 0 : _a.querySelectorAll(dropdownMobileViewChangeEventCunsumersSelector)) || [];
            allDependentChildren.forEach(function (child) {
                child.dispatchEvent(mobileViewChangeEvent);
            });
        });
        _this.hasTabs = false;
        _this.handleMutation = _this.cgThrottle(function (mutations) {
            if (_this._isMobile) {
                return;
            }
            var dropdownMenuArea = _this.dropdownMenuArea();
            var isOnlyDropdownMenuAreaMutated = mutations.every(function (mutation) { return mutation.target === dropdownMenuArea; });
            if (isOnlyDropdownMenuAreaMutated) {
                return;
            }
            _this.placeDropdown();
        });
        _this.onTargetClick = function (e) {
            if (!_this.isControlled()) {
                if (_this.getIsOpen()) {
                    _this._closeHandler('targetClick');
                    _this.close();
                }
                else {
                    _this.open();
                }
            }
        };
        _this.onTargetKeydown = function (e) {
            var _a, _b;
            var target = e.target;
            var tagName = target.tagName.toLowerCase();
            var isInlayButton = (_b = (_a = e.currentTarget) === null || _a === void 0 ? void 0 : _a.querySelector('[data-e2e="cg-field-inlay"]')) === null || _b === void 0 ? void 0 : _b.contains(target);
            if (e.key === 'Esc' || e.key === 'Escape') {
                if (_this.getIsOpen()) {
                    _this._closeHandler('Escape');
                    _this.close();
                }
            }
            if (_this.oldDropdownMenu()) {
                return;
            }
            if (tagName !== 'input' && (e.key === 'Enter' || e.key === ' ')) {
                e.preventDefault();
                if (_this.getIsOpen()) {
                    _this._closeHandler('targetClick');
                    _this.close();
                }
                else {
                    if (isInlayButton) {
                        return;
                    }
                    _this.open();
                    if (_this.state.isMobile) {
                        //it doesn't work in angular without setTimeout
                        _this.timeoutIds.push(setTimeout(function () {
                            _this.closeMobileViewBtn().focus();
                        }));
                    }
                }
            }
            if (e.key === 'Tab' && e.shiftKey && _this.getIsOpen()) {
                _this.close();
            }
            if (_this.isFlyOutMenuMode()) {
                if (e.key === 'Tab' && !e.shiftKey && _this.getIsOpen()) {
                    e.preventDefault();
                    focusFirstAvailable(_this.dropdownDoc());
                }
            }
            if (_this.isApplicationMenuMode()) {
                if (e.key === 'Tab' &&
                    _this.getIsOpen() &&
                    !_this.dropdownDoc().contains(document.activeElement)) {
                    _this._closeHandler('focusOut');
                    _this.close();
                }
                if (UP_DOWN_KEYS.includes(e.key)) {
                    e.preventDefault();
                    var checkPressedKeyBtn_1 = function () {
                        if (UP_KEYS.includes(e.key)) {
                            if (_this.lastItem()) {
                                _this.lastItem().focus();
                            }
                            else {
                                _this.setFocusOnFirstElement();
                            }
                        }
                        if (DOWN_KEYS.includes(e.key)) {
                            if (!_this.setFocusOnFirstElement() && _this.firstItem()) {
                                _this.firstItem().focus();
                            }
                        }
                    };
                    if (!_this.getIsOpen()) {
                        _this.open();
                    }
                    _this.timeoutIds.push(setTimeout(function () {
                        checkPressedKeyBtn_1();
                    }));
                }
            }
        };
        _this.onItemClick = function (e) {
            var target = e.target;
            _this._closeHandler('itemClick');
            if (!_this.isControlled() &&
                target.getAttribute('data-dropdown-menu-item')) {
                _this.close();
            }
        };
        _this.removeScrollLock = function () { };
        _this.removeClickOutside = function () { };
        _this.removeFocusTrap = function () { };
        _this.removeFocusOutsideHandlers = function () { };
        _this.onFocusOutsideAnimationFrame = null;
        _this.setUpFocusOutsideHandler = function () {
            var unsubscribeFocusOutside = _this.onFocusOutside(_this.dropdown(), function () {
                _this.onFocusOutsideAnimationFrame = _this.cgRequestAnimationFrame(function () {
                    if (document.activeElement !== _this.target() &&
                        !_this.dropdownDoc().contains(document.activeElement)) {
                        _this._closeHandler('focusOut');
                        _this.close();
                    }
                });
            });
            return function () {
                unsubscribeFocusOutside();
                cancelAnimationFrame(_this.onFocusOutsideAnimationFrame);
            };
        };
        _this.onResizeCallback = _this.cgDebounce(function () {
            _this.placeDropdown();
        }, 100);
        _this.dropdownPosition = '';
        _this.initTarget = _this.cgThrottle(function () {
            if (!_this.dropdownDoc()) {
                return;
            }
            var newTarget = _this.target();
            if (!newTarget) {
                _this.cleanupTarget();
                _this.detachFromDOM();
                return;
            }
            var currentTarget = _this._target;
            if (newTarget === currentTarget) {
                return;
            }
            if (currentTarget) {
                _this.cleanupTarget();
            }
            if (newTarget) {
                _this.setupTarget(newTarget);
                _this.attachToDOM();
            }
        });
        _this.cgSetTimeout = componentApi.cgSetTimeout.bind(_this);
        _this.userRequest = 'onUserRequest';
        _this.state = {};
        _this.state['_isOpen'] = _this.props.isOpen;
        _this.state['_isInDOM'] = false;
        _this.state['isMobile'] = false;
        _this.onHandleDropdownKeydown = _this.onHandleDropdownKeydown.bind(_this);
        _this.handleMedia = _this.handleMedia.bind(_this);
        _this.onResize = _this.onResize.bind(_this);
        _this.onScroll = _this.onScroll.bind(_this);
        _this.onCloseButtonClick = _this.onCloseButtonClick.bind(_this);
        return _this;
    }
    Dropdown.prototype.componentDidMount = function () {
        var _this = this;
        window.addEventListener('resize', this.onResize);
        window.addEventListener('scroll', this.onScroll);
        this.cgSetTimeout(function () {
            _this.initTarget();
        });
        this.attachMutationObservers();
    };
    Dropdown.prototype.componentWillUnmount = function () {
        var _a, _b;
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('scroll', this.onScroll);
        this.removeFocusOutsideHandlers();
        this.removeClickOutside();
        this.removeScrollLock();
        this.cleanupTarget();
        if (this.dropdown()) {
            this.dropdown().removeEventListener('cgItemClick', this.onItemClick);
        }
        this.timeoutIds.forEach(function (id) {
            clearTimeout(id);
        });
        (_a = this.mutationObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
        (_b = this.childrenMutationObserver) === null || _b === void 0 ? void 0 : _b.disconnect();
        this.toCancel.forEach(function (cancelableFunc) {
            cancelableFunc();
        });
    };
    Dropdown.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { ref: this.dropdownDocRef, role: this.getDropdownRole(), "aria-modal": this.getDropdownAriaModal(), "aria-labelledby": this.getDropdownAriaLabelledby(), onKeyDown: function (event) { return _this.onHandleDropdownKeydown(event); }, className: "cg-dropdown-doc-ref" }, this.state._isInDOM ? (React.createElement("div", { "data-e2e": this.props.dataE2e, className: 'cg-dropdown ' +
                (this.state.isMobile ? 'cg-dropdown-mobile ' : '') },
            React.createElement(MqlListener, { onMediaChange: function (event) {
                    return _this.handleMedia(event);
                } }),
            React.createElement(Fullscreen, { mobileMode: "fullscreen", childBodySelector: ".cg-dropdown-menu-area", fullscreenBreakpoint: this.props.fullscreenBreakpoint },
                React.createElement("div", { ref: this.dropdownRef, "data-e2e": "cg-menu-wrapper", "data-dropdown-focus": "dropdown", className: 'cg-dropdown-menu-wrapper ' +
                        (this.getIsOpen() ? 'cg-is-open ' : '') +
                        (this.getHasTabs() ? 'cg-has-tabs ' : '') },
                    this.state.isMobile ? (React.createElement("div", { className: "cg-dropdown-close-area" },
                        React.createElement(ButtonFieldIconClosePrivate, null,
                            React.createElement("button", { ref: this.closeMobileViewBtnRef, type: "button", onClick: this.onCloseButtonClick },
                                React.createElement(Iconsvg, { isFill: true, name: "close" }),
                                React.createElement(SrOnly, null, this.getI18n().srCloseDropdownLabel ||
                                    this.getI18n().closeDropdown))))) : null,
                    React.createElement("div", { ref: this.dropdownMenuAreaRef, "data-e2e": "cg-dropdown-menu-area", className: "cg-dropdown-menu-area" }, this.getIsOpen() ? (React.createElement(React.Fragment, null, this.props.children)) : null))))) : null));
    };
    Dropdown.prototype.getI18n = function () {
        return __assign(__assign({}, DEFAULT_DROPDOWN_I18N), this.props.i18n);
    };
    Dropdown.prototype.target = function () {
        var _a;
        var targetSelector = this.props.targetSelector;
        if (!targetSelector) {
            console.warn('Missing selector for dropdown target');
            return null;
        }
        else {
            var target = (_a = this.dropdownDoc().ownerDocument) === null || _a === void 0 ? void 0 : _a.querySelector(targetSelector);
            if (!target) {
                target = findTargetForAngular(targetSelector, this.dropdownDoc());
            }
            if (!target) {
                console.warn('Dropdown cannot find its target ', this.props.targetSelector, " and won't work. The target should be in DOM when dropdown initializes.");
            }
            return target;
        }
    };
    Dropdown.prototype.isControlled = function () {
        return this.props.controlMode === 'controlled';
    };
    Dropdown.prototype.firstItem = function () {
        var _a;
        return (_a = this.dropdownList()) === null || _a === void 0 ? void 0 : _a.querySelector('[tabindex="-1"]:not([role="separator"])');
    };
    Dropdown.prototype.lastItem = function () {
        return dropdownRecursiveFindingLastItem(this.dropdownList(), this.props.menuMode, this.state.isMobile);
    };
    Dropdown.prototype.oldDropdownMenu = function () {
        var _a;
        return (_a = this.dropdownDoc()) === null || _a === void 0 ? void 0 : _a.querySelector('[data-dropdown-focus="dropdown-menu"]');
    };
    Dropdown.prototype.dropdownList = function () {
        var _a;
        return (_a = this.dropdownDoc()) === null || _a === void 0 ? void 0 : _a.querySelector('[data-dropdown-focus="dropdown-list"]');
    };
    Dropdown.prototype.activeTab = function () {
        var _a;
        return (_a = this.dropdownDoc()) === null || _a === void 0 ? void 0 : _a.querySelector('.cg-dropdown-tab-selected');
    };
    Dropdown.prototype.getIsOpen = function () {
        if (this.isControlled()) {
            return this.props.isOpen;
        }
        else {
            return this.state._isOpen;
        }
    };
    Dropdown.prototype.open = function () {
        if (!this.isControlled()) {
            this.writeState('_isOpen', true);
            this._target.classList.add('cg-is-active');
        }
        this.emit(this.userRequest, true);
    };
    Dropdown.prototype.close = function () {
        if (!this.isControlled()) {
            this.writeState('_isOpen', false);
        }
        this.emit(this.userRequest, false);
    };
    Dropdown.prototype.dropdown = function () {
        return this.dropdownRef ? this.dropdownRef.current : null;
    };
    Dropdown.prototype.dropdownDoc = function () {
        return this.dropdownDocRef.current;
    };
    Dropdown.prototype.closeMobileViewBtn = function () {
        return this.closeMobileViewBtnRef
            ? this.closeMobileViewBtnRef.current
            : null;
    };
    Dropdown.prototype.dropdownTabsBar = function () {
        var _a;
        return (_a = this.dropdown()) === null || _a === void 0 ? void 0 : _a.querySelector('[data-dropdown-focus="dropdown-tab-bar"]');
    };
    Dropdown.prototype.dropdownSearchField = function () {
        var _a;
        return (_a = this.dropdown()) === null || _a === void 0 ? void 0 : _a.querySelector('[data-dropdown-focus="dropdown-search-field"]');
    };
    Dropdown.prototype.dropdownMenuArea = function () {
        return this.dropdownMenuAreaRef ? this.dropdownMenuAreaRef.current : null;
    };
    Dropdown.prototype.handleMedia = function (breakpoint) {
        var isMobile = BREAKPOINTS_FROM[breakpoint] <=
            BREAKPOINTS_FROM[this.props.fullscreenBreakpoint];
        this.writeState('isMobile', isMobile);
        this._isMobile = isMobile;
        this.placeDropdown();
        this.setDropdownAttrs(this._isMobile);
        this.notifyChildrenAboutMobileView(this._isMobile);
    };
    Dropdown.prototype.isApplicationMenuMode = function () {
        return this.props.menuMode === 'application';
    };
    Dropdown.prototype.isFlyOutMenuMode = function () {
        return this.props.menuMode === 'flyOut';
    };
    Dropdown.prototype.onHandleDropdownKeydown = function (event) {
        var _this = this;
        var _a;
        if (['Esc', 'Escape'].includes(event.key)) {
            event.stopPropagation();
            this._closeHandler('Escape');
            this.close();
            return;
        }
        if (this.oldDropdownMenu()) {
            return;
        }
        var target = event.target;
        var isDropdownListboxPressed = !!((_a = event.target) === null || _a === void 0 ? void 0 : _a.querySelector('[data-dropdown-focus="dropdown-listbox"]'));
        var handleTabKeydown = function () {
            var _a;
            if (_this.state.isMobile) {
                event.preventDefault();
                _this.closeMobileViewBtn().focus();
            }
            else {
                (_a = _this.target()) === null || _a === void 0 ? void 0 : _a.setAttribute('tabindex', '-1');
                _this._closeHandler('focusOut');
                _this.close();
                // the delay is necessary because the tabindex attribute change should be after the focus is set
                _this.timeoutIds.push(setTimeout(function () {
                    var _a;
                    (_a = _this.target()) === null || _a === void 0 ? void 0 : _a.setAttribute('tabindex', '0');
                }));
            }
        };
        if (event.key === 'Tab' && target === this.lastItem() && !event.shiftKey) {
            handleTabKeydown();
            return;
        }
        if (['Enter', ' '].includes(event.key) &&
            target === this.closeMobileViewBtn()) {
            event.preventDefault();
            this._closeHandler('closeButton');
            this.close();
            return;
        }
        if ((event.key === 'Enter' ||
            (event.key === ' ' && this.isApplicationMenuMode())) &&
            !isDropdownListboxPressed &&
            ((this.dropdownTabsBar() &&
                !this.dropdownTabsBar().contains(document.activeElement)) ||
                !this.dropdownTabsBar())) {
            event.preventDefault();
            this.onItemClick(event);
        }
        if (this.isApplicationMenuMode()) {
            if (event.key === 'Tab' && !event.shiftKey) {
                handleTabKeydown();
            }
            if (ARROW_KEYS.includes(event.key)) {
                event.preventDefault();
            }
            var isTabOrSearchField = [
                'dropdown-tab-btn',
                'dropdown-search-field',
            ].includes(target.getAttribute('data-dropdown-focus'));
            if (DOWN_KEYS.includes(event.key)) {
                if (isTabOrSearchField) {
                    if (this.firstItem()) {
                        this.firstItem().focus();
                    }
                    else {
                        if (this.state.isMobile) {
                            this.closeMobileViewBtn().focus();
                        }
                        else {
                            this.target().focus();
                        }
                    }
                    return;
                }
                if (target === this.lastItem()) {
                    if (this.state.isMobile) {
                        this.closeMobileViewBtn().focus();
                    }
                    else {
                        this.target().focus();
                    }
                }
                if (target === this.closeMobileViewBtn()) {
                    if (!this.setFocusOnFirstElement() && this.firstItem()) {
                        this.firstItem().focus();
                    }
                }
            }
            if (UP_KEYS.includes(event.key)) {
                if (isTabOrSearchField) {
                    if (this.state.isMobile) {
                        this.closeMobileViewBtn().focus();
                    }
                    else {
                        this.target().focus();
                    }
                }
                if (target === this.firstItem()) {
                    if (!this.setFocusOnFirstElement()) {
                        if (this.state.isMobile) {
                            this.closeMobileViewBtn().focus();
                        }
                        else {
                            this.target().focus();
                        }
                    }
                }
                if (target === this.closeMobileViewBtn()) {
                    if (this.lastItem()) {
                        this.lastItem().focus();
                    }
                    else {
                        this.setFocusOnFirstElement();
                    }
                }
            }
        }
    };
    Dropdown.prototype.setFocusOnFirstElement = function () {
        var elem = this.activeTab() || this.dropdownSearchField();
        if (elem) {
            elem.focus();
            return true;
        }
        return false;
    };
    Dropdown.prototype.attachMutationObservers = function () {
        var _this = this;
        if (!this.dropdownMenuArea())
            return;
        if (!this.mutationObserver) {
            this.mutationObserver = new MutationObserver(this.handleMutation);
            this.mutationObserver.observe(this.dropdownMenuArea(), {
                childList: true,
                subtree: true,
            });
        }
        if (!this.childrenMutationObserver) {
            this.childrenMutationObserver = new MutationObserver(function () {
                _this.notifyChildrenAboutMobileView(_this._isMobile);
            });
            this.childrenMutationObserver.observe(this.dropdownMenuArea(), {
                childList: true,
                subtree: true,
            });
        }
    };
    Dropdown.prototype.cg_change = function (prevProps) {
        var prevIsOpen = this.isControlled()
            ? prevProps.isOpen
            : prevProps._isOpen;
        this.setDropdownAttrs();
        this.attachMutationObservers();
        if ((prevProps.targetSelector !== undefined &&
            prevProps.targetSelector !== this.props.targetSelector &&
            this.props.targetSelector) ||
            (prevIsOpen !== undefined && prevIsOpen !== this.getIsOpen()) ||
            (prevProps.isMobile !== undefined && this.state.isMobile)) {
            if (!this.oldDropdownMenu()) {
                this.setDropdownAttrs();
            }
        }
        if (prevProps.isMobile === false &&
            this.state.isMobile &&
            this.getIsOpen()) {
            this.removeScrollLock();
            this.removeScrollLock = scrollLock();
            this.removeFocusTrap();
            this.removeFocusTrap = focusTrap(this.dropdown());
            this.removeFocusOutsideHandlers();
            this.dropdown().removeAttribute('style');
            this.dropdownMenuArea().removeAttribute('style');
        }
        if (prevProps.isMobile === true && !this.state.isMobile) {
            this.removeScrollLock();
            this.placeDropdown();
            this.removeFocusTrap();
            this.removeFocusOutsideHandlers();
            this.removeFocusOutsideHandlers = this.setUpFocusOutsideHandler();
        }
        if (this.isPropChanged('targetSelector', prevProps)) {
            if (prevProps.targetSelector !== '')
                this.closed();
            this.initTarget();
        }
        if (prevIsOpen === false && this.getIsOpen()) {
            if (this.dropdown()) {
                this.opened();
                if (this.dropdownTabsBar()) {
                    this.hasTabs = true;
                }
                if (this.state.isMobile) {
                    this.removeScrollLock();
                    this.removeScrollLock = scrollLock();
                }
            }
            else {
                this.initTarget();
            }
        }
        else if (prevIsOpen === true && this.getIsOpen() === false) {
            if (this.dropdown()) {
                this.closed();
                if (this.dropdownTabsBar()) {
                    this.hasTabs = false;
                }
                if (this.state.isMobile) {
                    this.removeScrollLock();
                }
            }
        }
        if (prevProps._isInDOM === false &&
            this.state._isInDOM &&
            this.getIsOpen()) {
            this.opened();
            if (this.dropdownTabsBar()) {
                this.hasTabs = true;
            }
        }
        if (prevProps._isInDOM === false && this.state._isInDOM === true) {
            var ownerDocument = this.dropdownDocRef.current.ownerDocument;
            this.dropdownPosition = ownerDocument.defaultView.getComputedStyle(this.dropdown()).position;
        }
    };
    Dropdown.prototype.getHasTabs = function () {
        return this.hasTabs;
    };
    Dropdown.prototype.focusTargetIfExist = function () {
        if (!this._target) {
            return;
        }
        this._target.focus();
    };
    Dropdown.prototype.onFocusOutside = function (el, cb) {
        var shift = false;
        var onKeyDown = function (e) {
            if (e.key === 'Shift') {
                shift = true;
                return;
            }
            if (e.key !== 'Tab') {
                return;
            }
            var activeElement = document.activeElement;
            var focusables = getFocusables(el);
            var firstFocusable = focusables[0];
            var lastFocusable = focusables[focusables.length - 1];
            var goesBeforeDropdown = activeElement === firstFocusable && shift;
            var goesAfterDropdown = activeElement === lastFocusable && !shift;
            if (goesBeforeDropdown || goesAfterDropdown) {
                cb();
            }
        };
        var onKeyUp = function (e) {
            if (e.key === 'Shift') {
                shift = false;
            }
        };
        document.addEventListener('keydown', onKeyDown);
        document.addEventListener('keyup', onKeyUp);
        return function () {
            document.removeEventListener('keydown', onKeyDown);
            document.removeEventListener('keyup', onKeyUp);
        };
    };
    Dropdown.prototype.opened = function () {
        var _this = this;
        var _a;
        this.placeDropdown();
        this.removeClickOutside();
        this.removeClickOutside = clickOutside([this.dropdown(), this._target], function () {
            _this._closeHandler('clickOutside');
            _this.close();
        });
        this.removeFocusOutsideHandlers();
        if (this.oldDropdownMenu()) {
            focusFirstAvailable(this.dropdown());
        }
        if (!this.state.isMobile) {
            this.removeFocusOutsideHandlers = this.setUpFocusOutsideHandler();
        }
        else {
            this.removeFocusTrap = focusTrap(this.dropdown());
            this.closeMobileViewBtn().focus();
        }
        (_a = this._target) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-expanded', 'true');
        this._target.classList.add('cg-is-active');
        this.dropdown().addEventListener('cgItemClick', this.onItemClick);
    };
    Dropdown.prototype.closed = function () {
        this.removeFocusOutsideHandlers();
        this.removeFocusTrap();
        this.removeClickOutside();
        this.removeScrollLock();
        if (this._target) {
            this._target.setAttribute('aria-expanded', 'false');
            this._target.classList.remove('cg-is-active');
        }
        if (this.dropdown()) {
            this.dropdown().removeEventListener('cgItemClick', this.onItemClick);
            this.dropdown().removeAttribute('style');
            this.dropdownMenuArea().removeAttribute('style');
        }
    };
    Dropdown.prototype.placeDropdown = function () {
        var _this = this;
        var _a, _b;
        if (!isSsr) {
            (_a = this.dropdownMenuArea()) === null || _a === void 0 ? void 0 : _a.scrollTo(0, 0);
        }
        if (this.state._isInDOM &&
            this.dropdown() &&
            this.getIsOpen() &&
            !this._isMobile) {
            this.dropdown().removeAttribute('style');
            (_b = this.dropdownMenuArea()) === null || _b === void 0 ? void 0 : _b.removeAttribute('style');
            var _c = this._target.getBoundingClientRect(), bottom = _c.bottom, top_1 = _c.top;
            var dropdownHeight = this.dropdown().getBoundingClientRect().height;
            var availableVerticalSpace = Math.max(window.innerHeight - bottom, top_1) - 8;
            if (dropdownHeight > availableVerticalSpace) {
                this.dropdownMenuArea().setAttribute('style', "height: ".concat(availableVerticalSpace, "px"));
            }
            var placementOptions = this.props.placementOptions;
            var positions = placementOptions.positions
                ? placementOptions.positions
                : [
                    'bottom-right',
                    'bottom-left',
                    'top-right',
                    'top-left',
                ];
            var offsets = {
                'top-right': {
                    topOffset: -2,
                    leftOffset: 0,
                },
                'bottom-right': {
                    topOffset: 2,
                    leftOffset: 0,
                },
                'bottom-left': {
                    topOffset: 2,
                    leftOffset: 0,
                },
                'top-left': {
                    topOffset: -2,
                    leftOffset: 0,
                },
            };
            if (placementOptions.offsets) {
                for (var key in placementOptions.offsets) {
                    offsets[key] = __assign(__assign({}, offsets[key]), placementOptions.offsets[key]);
                }
            }
            // width should be set before every call smartPlacement
            if (this.props.dropdownWidth && !this.state.isMobile) {
                ['width', 'maxWidth'].forEach(function (property) {
                    _this.dropdown().style[property] = _this.props.dropdownWidth;
                });
            }
            smartPlacement(this._target, this.dropdown(), offsets, positions);
        }
    };
    Dropdown.prototype.onResize = function () {
        this.onResizeCallback();
    };
    Dropdown.prototype.onScroll = function () {
        var _this = this;
        var throttleFunction = this.cgThrottle(function () {
            if (_this.dropdownPosition === 'fixed' && _this.getIsOpen()) {
                _this.placeDropdown();
            }
        });
        throttleFunction();
    };
    Dropdown.prototype.onCloseButtonClick = function () {
        this._closeHandler('closeButton');
        this.close();
    };
    Dropdown.prototype.setupTarget = function (target) {
        var _a, _b, _c;
        this._target = target;
        if (this.props.setAriaHasPopup) {
            (_a = this._target) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-haspopup', 'true');
        }
        (_b = this._target) === null || _b === void 0 ? void 0 : _b.addEventListener('click', this.onTargetClick);
        (_c = this._target) === null || _c === void 0 ? void 0 : _c.addEventListener('keydown', this.onTargetKeydown);
        if (this.dropdown() && this.getIsOpen()) {
            this.opened();
        }
    };
    Dropdown.prototype.cleanupTarget = function () {
        if (this._target) {
            if (this.props.setAriaHasPopup) {
                this._target.removeAttribute('aria-haspopup');
            }
            this._target.removeEventListener('click', this.onTargetClick);
            this._target.removeEventListener('keydown', this.onTargetKeydown);
            this._target = null;
        }
    };
    Dropdown.prototype.attachToDOM = function () {
        if (this._target) {
            this.writeState('_isInDOM', true);
        }
    };
    Dropdown.prototype.detachFromDOM = function () {
        this.writeState('_isInDOM', false);
    };
    Dropdown.prototype.isPropChanged = function (propName, prevProps) {
        return (prevProps[propName] !== undefined &&
            prevProps[propName] !== this.props[propName]);
    };
    Dropdown.prototype.setDropdownAttrs = function (isMobile) {
        var _a;
        if (isMobile === void 0) { isMobile = this.state.isMobile; }
        var btnMore = (_a = document.body) === null || _a === void 0 ? void 0 : _a.querySelector(this.props.targetSelector);
        if (!btnMore) {
            return;
        }
        this.moreBtnId = assignAndGetId(btnMore);
        if (this.isFlyOutMenuMode() && isMobile && this.props.setAriaHasPopup) {
            btnMore.setAttribute('aria-haspopup', 'dialog');
        }
        if (this.isApplicationMenuMode() && this.props.setAriaHasPopup) {
            btnMore.setAttribute('aria-haspopup', 'menu');
        }
        this.setDropdownTabMenuAttr();
        this.setDropdownMenuAttr();
        if (!isMobile &&
            btnMore.getAttribute('aria-haspopup') &&
            this.isFlyOutMenuMode()) {
            btnMore.removeAttribute('aria-haspopup');
        }
        var isOpen = false;
        if (this.getIsOpen()) {
            isOpen = true;
        }
        btnMore.setAttribute('aria-expanded', isOpen.toString());
    };
    Dropdown.prototype.getDropdownAriaLabelledby = function () {
        return this.state.isMobile
            ? this.props.srLabelledby || this.moreBtnId
            : null;
    };
    Dropdown.prototype.getDropdownAriaModal = function () {
        return this.state.isMobile ? this.getIsOpen() : null;
    };
    Dropdown.prototype.getDropdownRole = function () {
        return this.state.isMobile ? 'dialog' : null;
    };
    Dropdown.prototype.setDropdownMenuAttr = function () {
        if (this.dropdownList()) {
            var id = this.activeTab()
                ? this.activeTab().id
                : this.props.srLabelledby
                    ? this.props.srLabelledby
                    : this.moreBtnId;
            this.dropdownList().setAttribute('aria-labelledby', id);
        }
    };
    Dropdown.prototype.setDropdownTabMenuAttr = function () {
        var _a;
        var dropdowmTabsBar = (_a = this.dropdownDoc()) === null || _a === void 0 ? void 0 : _a.querySelector('[data-dropdown-focus="dropdown-tab-bar"]');
        if (dropdowmTabsBar) {
            dropdowmTabsBar.setAttribute('aria-labelledby', this.moreBtnId);
        }
    };
    Dropdown.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.cg_change(__assign(__assign({}, prevProps), prevState));
    };
    Dropdown.defaultProps = {
        dataE2e: 'cg-dropdown',
        i18n: DEFAULT_DROPDOWN_I18N,
        slot: '',
        menuMode: 'application',
        targetSelector: '',
        controlMode: 'uncontrolled',
        isOpen: false,
        setAriaHasPopup: true,
        dropdownWidth: null,
        fullscreenBreakpoint: 'XS',
        placementOptions: {
            positions: ['bottom-right', 'bottom-left', 'top-right', 'top-left'],
            offsets: {
                'top-right': {
                    topOffset: -2,
                    leftOffset: 0,
                },
                'bottom-right': {
                    topOffset: 2,
                    leftOffset: 0,
                },
                'bottom-left': {
                    topOffset: 2,
                    leftOffset: 0,
                },
                'top-left': {
                    topOffset: -2,
                    leftOffset: 0,
                },
            },
        },
    };
    Dropdown.displayName = 'Dropdown';
    return Dropdown;
}(React.Component));
export { Dropdown };
